import React from 'react';
import { experiences } from '../data/portfolioData';
import { Calendar, MapPin, Building, ChevronRight } from 'lucide-react';

const Experience = () => {
  return (
    <section id="experience" className="py-5 bg-gray-900/50">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            <span className="text-primary">Mon expérience</span>
          </h2>
          <p className="text-gray-400 text-lg max-w-3xl mx-auto">
            Parcours académique et expériences professionnelles
          </p>
        </div>
        
        {/* Timeline */}
        <div className="max-w-4xl mx-auto">
          {experiences.map((exp, index) => (
            <div 
              key={exp.id} 
              className={`relative pl-10 pb-12 ${index !== experiences.length - 1 ? 'border-l-2 border-gray-700' : ''}`}
            >
              {/* Point de la timeline */}
              <div className="absolute left-[-9px] top-0 w-4 h-4 bg-primary rounded-full border-4 border-dark"></div>
              
              {/* Carte d'expérience */}
              <div className="bg-gray-800/30 p-6 rounded-xl border border-gray-700 ml-6 hover:border-primary/50 transition-all duration-300">
                <div className="flex flex-col md:flex-row md:items-center justify-between mb-4">
                  <div>
                    <h3 className="text-xl font-bold">{exp.title}</h3>
                    <div className="flex items-center gap-2 mt-1 text-gray-300">
                      <Building size={16} />
                      <span>{exp.company}</span>
                    </div>
                  </div>
                  
                  <div className="flex flex-col items-start md:items-end mt-2 md:mt-0">
                    <div className="flex items-center gap-1 text-gray-400">
                      <Calendar size={16} />
                      <span>{exp.period}</span>
                    </div>
                    <div className="flex items-center gap-1 text-gray-400 mt-1">
                      <MapPin size={16} />
                      <span>{exp.location}</span>
                    </div>
                  </div>
                </div>
                
                {/* Description */}
                <ul className="space-y-2 mt-4">
                  {exp.description.map((item, idx) => (
                    <li key={idx} className="flex items-start gap-2 text-gray-300">
                      <ChevronRight size={16} className="text-primary mt-1 flex-shrink-0" />
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
        {/* Formation complémentaire */}
        <div className="mt-20 max-w-4xl mx-auto">
          <h3 className="text-2xl font-bold mb-8 text-center">Formation complémentaire</h3>
          <div className="grid md:grid-cols-3 gap-6">
            {[
              { title: "Microsoft Certified : Principes de base d’Azure", issuer: "Microsoft", year: "2026" }
            ].map((cert, index) => (
              <div key={index} className="bg-gray-800/30 p-6 rounded-xl border border-gray-700 hover:border-primary/50 transition-all">
                <h4 className="font-semibold mb-2">{cert.title}</h4>
                <div className="text-gray-400 text-sm">
                  <div>{cert.issuer}</div>
                  <div>{cert.year}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
        
      </div>
    </section>
  );
};

export default Experience;